<div [formGroup]="form">
	<nz-form-item *ngIf="inline == false">
		<nz-form-label [nzSpan]="10"  [nzRequired]="wrapper.element.required">{{ wrapper.element.name }}</nz-form-label>
		<nz-form-control [nzSpan]="10" [nzAutoTips]="wrapper.autoTips">
			<input nz-input type="email" [formControlName]="toControlKey(wrapper.element)" [readonly]="readonly" />
		</nz-form-control>
	</nz-form-item>
	<nz-form-item *ngIf="inline == true">
		<nz-form-control [nzAutoTips]="wrapper.autoTips">
			<input nz-input type="email" [formControlName]="toControlKey(wrapper.element)" [readonly]="readonly" />
		</nz-form-control>
	</nz-form-item>
</div>
